import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'
import { CustomAlertType } from 'builder/modules/jobSearch/types'

export const useNewCustomAlert = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async ({
      targetRole,
      location,
      locationId,
      onlyRemoteJobs,
      frequency,
    }: CustomAlertType): Promise<void> => {
      const res = await baseClient.post('/job-alerts/v1/custom-subscriptions', {
        location,
        target_role: targetRole,
        location_id: locationId,
        only_remote_jobs: onlyRemoteJobs,
        frequency,
      })
      return res.data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['useGetCustomAlerts'])
      },
    },
  )
}
